import type WhiteboardController from './controllers/WhiteboardController';
import React from 'react';
import styles from './errors.module.css';

interface ErrorHandlerProps {
  error?: string;
  controller: WhiteboardController;
  children: React.ReactNode;
}

class ErrorHandler extends React.Component<ErrorHandlerProps> {
  componentDidCatch(error) {
    this.props.controller.actionHandleError(error);
  }

  static getDerivedStateFromError() {
    return {};
  }

  render() {
    if (this.props.error) {
      return (
        <div>
          <div className={styles.overlay}>
            <p>
              <aha-icon icon='fa-regular fa-face-disappointed' />
            </p>
            <p>
              There was a problem with this whiteboard. Please refresh to try
              again.
            </p>
            <p>
              If the problem persists please contact support@aha.io. with error
              number <code>{this.props.error}</code>.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorHandler;
